(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  const deleteFitTimeText = () => {
    const deleteButton = document.querySelectorAll('[data-cart-item-delete]');
    const fitTimeText = document.querySelector('.js-fitTimeText');

    deleteButton.forEach((button) => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          const fitTimeEl = document.querySelectorAll('[data-cart-set-id]');
          if (fitTimeEl.length <= 0) {
            fitTimeText.classList.add('is-hidden');
          }
        }, 1000);
      });
    });
  };

  window.addEventListener('DOMContentLoaded', () => {
    deleteFitTimeText();
  });

  } catch(e) { console.error(e); }
})();
})();
